import * as _ from 'lodash'
import searchMap from '@/views/search/utils/searchMap'

export default {
  methods: {
    changeFirm (title) { // 点击企业图表触发
      let route = {
        // name: 'searchType',
        path: '',
        params: {
          type: 'all',
          keyword: title
        }
      }
      route.path = this.createdPath() + '/' + route.params.type + '/1/' + route.params.keyword
      this.$router.push(route)
    },
    createdPath () {
      let path = '/searchType'
      if (this.$route && this.$route.path) {
        const index = this.$route.path.indexOf('searchType')
        if (index === -1) {
          path = this.$route.path + path
        } else {
          const snippet = this.$route.path.slice(0, index + 10)
          path = snippet
        }
      }
      return path
    },
    changeSearchUrl (val) {
      let id = _.split(val.sourceAsMap.contentid, '_')[1]
      const kgId = encodeURIComponent(val.sourceAsMap.title)
      const typeItem = _.find(searchMap.typeAgg, ['value', val.sourceAsMap.column])
      let type = (typeItem && typeItem.id) || val.type
      let path = `${this.$route.path}/searchType/all/1//searchDetail/${id}/${type}/${kgId}`
      if (!val.sourceAsMap.contentid) { // 研报
        id = val.sourceAsMap.eid
        type = '研报'
        path = `${this.$route.path}/searchType/all/1//searchDetail/${id}/${type}/${kgId}/${val.sourceAsMap.type}`
      }
      let query = ''
      if (val.sourceAsMap) {
        // 配置kw传参
        if (val.sourceAsMap['tags']) {
          query = `${query}kw=${val.sourceAsMap['tags'].toString()}`
        }
        if (val.sourceAsMap['one_level_state']) {
          query = `${query}&country=${val.sourceAsMap['one_level_state'].toString()}`
        }
      }
      path = path + '?' + query
      this.$router.push({path})
    }
  }
}
